import { useLocation } from "react-router-dom";
import { useWithSessionData } from "./use-with-session-data";
import { useEffect } from "react";
import { pageStartEventBuilder, sendEvent } from "../utils/event-helpers";


export function RouteTracker() {
    const location = useLocation();
    const { userId, sessionId, sessionIdLoaded } = useWithSessionData();
  
    useEffect(() => {
      if (!sessionIdLoaded || !userId || !sessionId) return;
      
      const pageEvent = pageStartEventBuilder(userId, sessionId, window.location.origin + location.pathname);
      sendEvent(pageEvent);
    }, [location.pathname, sessionIdLoaded, userId, sessionId]);
  
    return null;
  }